import './bootstrap';

import { createSSRApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue, route } from 'ziggy-js';
import { config as fontAwesomeConfig } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { __t } from './helpers';
import 'moment/min/locales';
import VueSmoothScroll from 'vue3-smooth-scroll';

fontAwesomeConfig.autoAddCss = false;

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
    progress: {
        delay: 0,
        color: '#4B5563',
        includeCSS: true,
        showSpinner: true,
    },
    title: (title) => title ? `${title} - ${appName}` : appName,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const ziggy = { ...props.initialPage.props.ziggy };

        delete ziggy.location;

        globalThis.Ziggy = ziggy;
        globalThis.route = (name, params, absolute) => route(name, params, absolute, ziggy);

        const app = createSSRApp({ render: () => h(App, props) });

        app.use(plugin)
            .use(ZiggyVue, ziggy)
            .use(VueSmoothScroll, {
                duration: 500,
                updateHistory: false,
            })
            .component('font-awesome-icon', FontAwesomeIcon);

        app.config.globalProperties.__t = __t;

        return app.mount(el);
    },
});
